<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <title-categories-text />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <subtitle-categories-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <ordering-categories-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <status-categories-card />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <categories-image-card />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <b-button
          variant="primary"
          :disabled="dataItem.submitStatus"
          @click="submitForm"
        >
          Kaydet
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import TitleCategoriesText from '@/views/Categories/Elements/TitleText.vue'
import SubtitleCategoriesText from '@/views/Categories/Elements/SubtitleText.vue'
import OrderingCategoriesCard from '@/views/Categories/Elements/OrderingCard.vue'
import StatusCategoriesCard from '@/views/Categories/Elements/StatusCard.vue'
import CategoriesImageCard from '@/views/Categories/Elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BButton,
    CategoriesImageCard,
    StatusCategoriesCard,
    OrderingCategoriesCard,
    SubtitleCategoriesText,
    TitleCategoriesText,
    BRow,
    BCol,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mediaType: 'image',
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['categories/dataItem']
    },
  },
}
</script>
